module.exports = __webpack_public_path__ + "media/components/util/logos/eezy-logo--white-9af94245d36f5ecc885e9c1a33329b1b.svg";